import { Icon as e } from "../icon/index.js";
import { cn as t } from "../cn.js";
import n from "./style.js";
import * as r from "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
// src/design/badge/index.tsx
var o = r.forwardRef(({ children: r, className: o, variant: s = "soft", colorScheme: c = "default", size: l = "md", icon: u, iconPosition: d = "left", dot: f = !1, removable: p = !1, onRemove: m, ...h }, g) => {
	let _ = {
		xs: "xs",
		sm: "xs",
		md: "sm",
		lg: "sm"
	}[l], v = `${s}-${c}`;
	return /* @__PURE__ */ a("span", {
		ref: g,
		className: t(n().root({
			variant: v,
			size: l
		}), o),
		...h,
		children: [
			f && /* @__PURE__ */ i("span", {
				className: t(n().dot({
					variant: v,
					size: l
				})),
				"aria-hidden": "true"
			}),
			u && d === "left" && /* @__PURE__ */ i(e, {
				name: u,
				size: _,
				className: n().icon({
					size: l,
					position: "left"
				})
			}),
			/* @__PURE__ */ i("span", { children: r }),
			u && d === "right" && /* @__PURE__ */ i(e, {
				name: u,
				size: _,
				className: n().icon({
					size: l,
					position: "right"
				})
			}),
			p && /* @__PURE__ */ i("button", {
				type: "button",
				onClick: (e) => {
					e.stopPropagation(), m?.();
				},
				className: n().removeButton({ size: l }),
				"aria-label": "Remove badge",
				children: /* @__PURE__ */ i(e, {
					name: "X",
					size: _
				})
			})
		]
	});
});
o.displayName = "Badge";
var s = r.forwardRef(({ className: e, colorScheme: r = "default", pulse: o = !1, size: s = "md", ...c }, l) => {
	let u = `fill-${r}`;
	return /* @__PURE__ */ a("span", {
		ref: l,
		className: t("relative inline-flex", e),
		...c,
		children: [/* @__PURE__ */ i("span", { className: t(n().dot({
			variant: u,
			size: s
		})) }), o && /* @__PURE__ */ i("span", { className: t("absolute inline-flex h-full w-full rounded-full opacity-75 animate-ping", n().dot({
			variant: u,
			size: s
		})) })]
	});
});
s.displayName = "Badge.Dot";
var c = r.forwardRef(({ children: e, className: r, spacing: a = "md", ...o }, s) => /* @__PURE__ */ i("div", {
	ref: s,
	className: t(n().group(a), r),
	...o,
	children: e
}));
c.displayName = "Badge.Group";
var l = Object.assign(o, {
	Dot: s,
	Group: c,
	getStyles: n
});
export { l as Badge, l as default };

//# sourceMappingURL=index.js.map